// TKT-2343 — Reporte por Item con items de opcion (form-option / form-yes-no).
//
// Ambos tipos guardan la respuesta escalar con la LLAVE de la opcion en ingles
// ("yes" / "no" / "na"); al llenar el formulario la app la traduce (FieldOption /
// FieldYesNo), asi que el reporte y sus descargas deben mostrar esa misma etiqueta
// y no la llave cruda.

const BASE_ITEM_TYPES = ['form-catalog', 'form-input-text', 'form-textarea', 'form-option']
const OPTION_TYPES = ['form-option', 'form-yes-no']
const TRANSLATED_KEYS = ['yes', 'no', 'na']

// Tipos de item que puede agregar cada reporte. El Reporte por Item ('answers')
// agrupa form-yes-no igual que form-option; el consolidado no lo soporta
// (ConsolidatedAnswers solo renderiza catalogo), asi que conserva su lista.
export function answersItemTypes (reportType) {
  return reportType === 'answers' ? [...BASE_ITEM_TYPES, 'form-yes-no'] : BASE_ITEM_TYPES
}

export function isOptionType (type) {
  return OPTION_TYPES.includes(type)
}

// Etiqueta a mostrar para una opcion: yes/no/na se traducen con `t`; cualquier
// otra opcion (texto libre del editor) sale tal cual.
export function optionLabel (value, t) {
  const key = typeof value === 'string' ? value.trim().toLowerCase() : value
  return TRANSLATED_KEYS.includes(key) ? t(key) : value
}

// Agrupa las respuestas de un item de opcion por valor. Cada fila conserva la
// llave cruda en `id` (para filtrar el detalle) y la etiqueta traducida en `name`.
export function groupOptionAnswers (answers, t) {
  const group = answers.reduce((r, a) => {
    r[a.value] = [...r[a.value] || [], a]
    return r
  }, {})
  const items = Object.keys(group).map(key => {
    const rows = group[key]
    const id = JSON.parse(key)
    const total = rows.reduce((sum, ans) => sum + ans.score, 0)
    return {
      id,
      name: optionLabel(id, t),
      count: rows.length,
      average: total / rows.length,
      last_result: rows[rows.length - 1].score
    }
  })
  return { items, group }
}

/**
 * TKT-2378 — CONTRATO del valor de un form-checkitem: en BD puede venir como booleano JSON
 * (`true`/`false`, camino legacy) o como `"1"`/`"0"` (offline-v2: SQLite guarda `answers.value` en
 * una columna TEXT, el `true` se lee como "1" y el drain lo manda asi; desde ago-2026 es ~90% de prod).
 * Todo lector del valor de una casilla debe pasar por aqui en vez de comparar contra `true`.
 * La escritura NO se cambia a 'true'/'false' a proposito: el PDF evalua `@if ($answer->value)` y en
 * PHP el string "false" es truthy (pintaria ✓ en casillas sin marcar); "1"/"0" lo entiende bien.
 * Acepta los mismos formatos que el backend (OccurrenceScoreCalculator). Las variantes de N/A quedan
 * como 'na' (el indeterminate-value de FieldCheckitem); null pasa tal cual.
 * @param {*} value
 * @returns {boolean|'na'|*}
 */
export function normalizeCheckitemValue (value) {
  if (value === true || value === 'true' || value === 1 || value === '1') return true
  if (value === false || value === 'false' || value === 0 || value === '0') return false
  if (typeof value === 'string' && value.replaceAll('"', '').toLowerCase() === 'na') return 'na'
  return value
}

/**
 * Texto en minusculas de una respuesta para comparar contra llaves ('efectivo', 'yes', 'na').
 * Acepta no-strings: un checkitem normalizado llega como booleano y `.toLowerCase()` directo truena.
 * @param {*} value
 * @returns {string|null} null solo para null/undefined.
 */
export function answerToLowerText (value) {
  return value === null || value === undefined ? null : String(value).toLowerCase().trim()
}
